import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { upgradePriceFrom2To4DecimalPlaces } from './upgradePriceFrom2To4DecimalPlaces.js';
export class OldGroupPrice extends AutoEncoder {
    price = 0;
    reducedPrice = null;
}
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], OldGroupPrice.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], OldGroupPrice.prototype, "reducedPrice", void 0);
/**
 * A group can have multiple prices, stored in an array. The pricing with the highest date or index is applied.
 */
export class OldGroupPrices extends AutoEncoder {
    id;
    startDate = null;
    /**
     * Whether the array count is per member of the same family (true) or only the same member (false)
     */
    sameMemberOnlyDiscount = false;
    /**
     * Count members in same category or only for the same group?
     */
    onlySameGroup = false;
    /**
     * The array contains prices: for first member, second member... If more members are present in a family (or member itself), the last price is used
     */
    prices = [OldGroupPrice.create({})];
    getPriceFor(reduced, alreadyRegisteredCount = 0) {
        if (this.prices.length == 0 || alreadyRegisteredCount < 0) {
            return 0;
        }
        const price = this.prices[Math.min(this.prices.length - 1, alreadyRegisteredCount)];
        if (reduced) {
            return price.reducedPrice ?? price.price;
        }
        return price.price;
    }
    /**
     * @deprecated
     */
    price = 0;
    /**
     * @deprecated
     */
    reducedPrice = null;
    /**
     * @deprecated
     * Second member in the family
     */
    familyPrice = null;
    /**
     * @deprecated
     * Third or later member
     */
    extraFamilyPrice = null;
}
__decorate([
    field({ decoder: StringDecoder, version: 2, defaultValue: () => uuidv4() })
], OldGroupPrices.prototype, "id", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], OldGroupPrices.prototype, "startDate", void 0);
__decorate([
    field({ decoder: BooleanDecoder, upgrade: () => false, version: 99 })
], OldGroupPrices.prototype, "sameMemberOnlyDiscount", void 0);
__decorate([
    field({ decoder: BooleanDecoder, upgrade: () => false, version: 99 })
], OldGroupPrices.prototype, "onlySameGroup", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(OldGroupPrice), version: 98, upgrade: function () {
            const arr = [
                OldGroupPrice.create({
                    price: this.price,
                    reducedPrice: this.reducedPrice,
                }),
            ];
            if (this.familyPrice !== null) {
                arr.push(OldGroupPrice.create({
                    price: this.familyPrice,
                    reducedPrice: (this.reducedPrice !== null && this.familyPrice < this.reducedPrice) ? null : this.reducedPrice,
                }));
                if (this.extraFamilyPrice !== null) {
                    arr.push(OldGroupPrice.create({
                        price: this.extraFamilyPrice,
                        reducedPrice: (this.reducedPrice !== null && this.extraFamilyPrice < this.reducedPrice) ? null : this.reducedPrice,
                    }));
                }
            }
            return arr;
        } })
], OldGroupPrices.prototype, "prices", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], OldGroupPrices.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], OldGroupPrices.prototype, "reducedPrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true, version: 22 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], OldGroupPrices.prototype, "familyPrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true, version: 22 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], OldGroupPrices.prototype, "extraFamilyPrice", void 0);
//# sourceMappingURL=OldGroupPrices.js.map